import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import './index.css'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { UserRoleProvider } from './contexts/UserRoleContext'
import { setupViteErrorHandler } from './utils/vite-error-handler'
import { initializeSentry } from './config/sentry'
import ErrorBoundary from './components/ErrorBoundary'

initializeSentry()

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
})

setupViteErrorHandler()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <UserRoleProvider>
          <App />
          <ReactQueryDevtools initialIsOpen={false} />
        </UserRoleProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  </StrictMode>
)
